import { Oeuvre } from "./oeuvre.js";

import { PaintingCanvas, PaintingFrame, PaintingPlainFrame } from "./painting-frame.js";

import {
	EdgesGeometry,
	Group,
	//TextureLoader,
	Mesh,
	LineSegments,
	LineBasicMaterial,
	MeshPhongMaterial,
	Material,
	BoxGeometry
} from '../../../src/js/three.module.js';

//import { MeshObjectLoader } from './mesh-object-loader.js';

import { getTextureLoader } from '../../utils/loaders/loader-manager.js';

export class Painting extends Oeuvre {

    constructor( uid, w, h, material, d ) {

        super( uid, w, h, d || 0 );

        this.isPainting = true;

        this.availPlanes = { floor: false, wall: true };

        this.frameObj = null;
        this.canvasObj = null;

        this.material = material;

        this.setMesh(new Mesh(new BoxGeometry(this.w, this.h, this.d || 0.01), this.material));

        this.$wireframe = new LineSegments(
            new EdgesGeometry(this.mesh.geometry),
            new LineBasicMaterial({ color: 0xffff00, linewidth: 3 })
        );

        this.$wireframes = new Group();
        this.$wireframes.add(this.$wireframe);

        this.$frames = { canvas: new PaintingPlainFrame({ rr: 0, material: { color: "#ffffff" } }), frame: new PaintingPlainFrame({ rr: 0, material: { color: "#000000" } }) };

        this.disableEdges = false;

        this.onSizeChanged();
    }
    setTextureSize(size) {
        this.material.$textureSize = size = parseInt(size);
        this.material.map = /* new TextureLoader() */ getTextureLoader().load("/i/" + this.$raw.with.oeuvre.img_uid + "?size=" + size + "x" + size + "!");
    }
    showHelpers(visible) {
        visible = visible == null ? true : !!visible;
        for (var key in this.$lastLine)
            if (this.$lastLine[key])
                this.$lastLine[key].visible = visible;
        if (this.helper_bottomLine)
            this.helper_bottomLine.visible = visible;

        this.onChanged();
    }
    onSizeChanged() {
        var g = this.mesh.geometry, vs = g.vertices;

        if (g.parameters.width != this.w) {
            g.parameters.width = this.w;
        }

        if (g.parameters.height != this.h) {
            g.parameters.height = this.h;
        }

        if (g.parameters.depth != this.d || 0.01) {
            g.parameters.depth = this.d || 0.01;

            /** Päivitetään kehysten syvyys, jotta ei synny epäsuhtaa (myös koska kehysten syvyyden asettamiseen ei ole käyttöliittymää. -m 16.03. */
            if (this.$frames) {
                if (this.$frames.frame)
                    this.$frames.frame.d = g.parameters.depth;
                if (this.$frames.canvas)
                    this.$frames.canvas.d = g.parameters.depth;
            }
        }

        g.vertices.forEach((v, i) => (v.x = (i >= 4 ? -1 : 1) * (this.w / 2)));

        vs[0].y = vs[1].y = vs[4].y = vs[5].y = g.parameters.height / 2;
        vs[2].y = vs[3].y = vs[6].y = vs[7].y = -g.parameters.height / 2;

        vs[0].z = vs[2].z = vs[5].z = vs[7].z = g.parameters.depth; //  g.parameters.depth / 2;
        vs[1].z = vs[3].z = vs[4].z = vs[6].z = 0; // -g.parameters.depth / 2;

        g.elementsNeedUpdate = true;

        this.width_cm = this.w * 100;
        this.height_cm = this.h * 100;
        this.depth_cm = this.d == null ? null : this.d * 100;

        this.$genFrames();

        this.onChanged();
    }
    /********************/
    setFrames(frameObj, canvasObj) {

        this.canvasObj = canvasObj || null;
        this.frameObj = frameObj || null;

        if (this.frameObj !== null && !(this.frameObj instanceof PaintingFrame))
            throw new TypeError("You can use only Painting.Frame as frame");

        if (this.canvasObj !== null && !(this.canvasObj instanceof PaintingCanvas))
            throw new TypeError("You can use only Painting.Frame as frame");

        this.clearFrames();

        this.mesh.remove(this.$wireframes);
        this.$wireframes = new Group();
        this.$wireframes.add(this.$wireframe);

        if (this.canvasObj) {

            this.mesh.add(this.canvasObj);

            if (this.disableEdges)
                this.canvasObj.visible = false;

            if (this.canvasObj.$wireframe)
                this.$wireframes.add(this.canvasObj.$wireframe);
        }

        if (this.frameObj) {

            this.mesh.add(this.frameObj);

            if (this.disableEdges)
                this.frameObj.visible = false;

            if (this.frameObj.$wireframe)
                this.$wireframes.add(this.frameObj.$wireframe);
        }

        this.$wireframes.visible = false;

        this.mesh.add(this.$wireframes);

        this.$refreshUserData();

        return this;
    }
    clearFrames(cont) {
        do {
            cont = false;
            for (var i in this.mesh.children) {
                if (this.mesh.children[i] instanceof PaintingFrame ||
                    this.mesh.children[i] instanceof PaintingCanvas) {
                    this.mesh.children.splice(i, 1);
                    cont = true;
                    break;
                }
            }
        } while (cont);

        this.mesh.remove(this.$wireframes);
        this.$wireframes = new Group();
        this.$wireframes.add(this.$wireframe);

        this.$refreshUserData();
        return this;
    }
    genFrames(opts) {
        opts = opts || {};
        var canvasObj = null, frameObj = null;
        var sw = this.w, sh = this.h, sgeo = this.mesh.geometry.clone(), ww = 0, hh = 0;

        var dd = this.d; // Paspiksen oletussyvyys

        if (opts.canvas) {

            // Jollei teoksella ole ole syvyyttä, koetetaan löytää sopiva syvyys muista tiedoista
            dd = opts.canvas.d || dd || this.mesh.geometry.parameters.depth;

            canvasObj = new PaintingCanvas(sgeo, this.w, this.h, dd, opts.canvas.rr, opts.canvas.material);

            ww = canvasObj.rr.left + canvasObj.rr.right;
            hh = canvasObj.rr.top + canvasObj.rr.bottom;

            sgeo = Painting.genSobj(sgeo, canvasObj.rr);
        }
        if (opts.frame) {

            // Etsitään kehyksen syvyyttä joko erikseen asetetusta tiedosta tai paspikse / teoksen pohjalta.
            dd = opts.frame.d || dd || this.mesh.geometry.parameters.depth;

            frameObj = new PaintingFrame(sgeo, sw + ww, sh + hh, dd, opts.frame.rr, opts.frame.material);
        }

        return this.setFrames(frameObj, canvasObj);
    }
    $genFrames() {
        var opts = {};

        if (this.$frames && this.$frames.canvas) {
            opts.canvas = new PaintingPlainFrame({
                d: this.$frames.canvas.d,
                rr: this.$frames.canvas.rr,
                material: new MeshPhongMaterial({ color: this.$frames.canvas.material.color })
            });
        }

        if (this.$frames && this.$frames.frame) {
            opts.frame = new PaintingPlainFrame({
                d: this.$frames.frame.d,
                rr: this.$frames.frame.rr,
                material: new MeshPhongMaterial({ color: this.$frames.frame.material.color })
            });
        }

        this.genFrames(opts);
    }
    // @TODO: johonkin watcheriin! Ei tätä saa kukaan muu ajaa.
    $onFramingChanged() {
        actStack.addUndo("oeuvre.framing.set", {
            oeuvre: this,
            old_frame: this.$frames.frame && this.$frames.frame.$old_settings,
            old_canvas: this.$frames.canvas && this.$frames.canvas.$old_settings,
            new_frame: this.$frames.frame && this.$frames.frame.$cur_settings,
            new_canvas: this.$frames.canvas && this.$frames.canvas.$cur_settings
        });
        this.$genFrames();
    }

    static genSobj( sgeo, rr ) {
        var nsgeo = sgeo.clone();
    
        var rs = {
            "left"  : [ "x", [4,5,6,7],  -1 ],
            "right" : [ "x", [0,1,2,3],  +1 ],
            "top"   : [ "y", [4,5,0,1],  +1 ],
            "bottom": [ "y", [6,7,2,3],  -1 ]
        }
    
        for ( var label in rr ) {
            for ( var e in rs[label][1] ) {
                nsgeo.vertices[ rs[label][1][e] ][ rs[label][0] ] += rs[label][2] * rr[label];
            }
        }
    
        return nsgeo;
    }

    static plainFrame = PaintingPlainFrame;
    static Canvas     = PaintingCanvas;
    static Frame      = PaintingFrame;  
}